import { createAction } from "@reduxjs/toolkit";

export const GET_NETWORK_ERROR = createAction("error/GET_NETWORK_ERROR");
export const SET_NETWORK_ERROR = createAction("error/SET_NETWORK_ERROR")

